import React, { FC, useState, useEffect } from 'react';
import classNames from 'classnames';
import { TextareaProps } from '@tarojs/components/types/Textarea';
import View from '../view';
import Text from '../text';
import BasicTextarea from './basic-textarea';

interface ITextareaProps extends TextareaProps {
  border?: boolean;
  showCount?: boolean;
}

const Textarea: FC<ITextareaProps> = ({ className, border = true, showCount = false, maxlength, onInput: propsOnInput, value: propsValue, ...restProps }) => {
  const rootCls = classNames('ink-textarea', { 'ink-textarea--border': border }, className);
  const [wordNum, setWordNum] = useState(0);

  useEffect(() => {
    setWordNum(propsValue?.length || 0);
  }, [propsValue]);

  return (
    <View className={rootCls}>
      <BasicTextarea
        {...restProps}
        value={propsValue}
        maxlength={maxlength}
        onInput={(e) => {
          setWordNum(e.detail?.value?.length);
          if (propsOnInput) {
            propsOnInput(e);
          }
        }}
      />
      {showCount && Number(maxlength) > 0 && (
        <View className="ink-textarea__word-limit">
          <Text className="ink-textarea__word-num">{wordNum}</Text>/{maxlength}
        </View>
      )}
    </View>
  );
};

export default Textarea;
